import { Skeleton } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useCreateChartTheme } from '../../../../../theme';

// Registrar los componentes de chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler);

const OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false }, // se puede habilitar si quieres
  },
  scales: {
    x: {
      display: false,
    },
    y: {
      grid: {
        display: true, // ✅ grilla activada
        drawBorder: false, // ✅ oculta la línea del eje Y
      },
      ticks: {
        display: false, // 🚫 ocultar labels
      },
    },
  },
};

export const GraficoLine = ({ labels, datasets, options, ...props }) => {
  const { chartTheme } = useCreateChartTheme({
    ...OPTIONS,
    ...options,
  });

  return (
    <>
      {labels && datasets && labels.length > 0 && datasets.length > 0 ? (
        <Line options={chartTheme} data={{ labels, datasets }} />
      ) : (
        <Skeleton
          variant='rectangular'
          width={'100%'}
          height={'100%'}
          sx={{ borderRadius: '8px' }}
        />
      )}
    </>
  );
};
